export const CalendarProviderType = Object.freeze({
    Microsoft: Symbol('microsoft'),
    Google: Symbol('google'),
    Onlive: Symbol('onlive'),
});
